// Invoices

export const invoiceStatusToStatusTagUse = {
  open: 'warning',
  past_due: 'error',
  paid: 'success',
  draft: 'default',
  voided: 'info'
};
export const invoiceStatusToStatusDotUse = {
  open: 'warning',
  past_due: 'danger',
  paid: 'success',
  draft: 'default',
  voided: 'info'
};
export const invoiceStatusToStatusDotMessage = {
  open: 'invoices.status.open',
  past_due: 'invoices.status.pastDue',
  paid: 'invoices.status.paid',
  draft: 'invoices.status.draft',
  voided: 'invoices.status.voided'
};

// Subscriptions

export const subscriptionDisplayStatusToStatusDotUse = {
  ACTIVE: 'success',
  FAILED_PAYMENT: 'danger',
  UNPAID: 'danger',
  SCHEDULED: 'info',
  CANCELED: 'default',
  EXPIRED: 'default',
  PAUSED: 'warning'
};
export const subscriptionDisplayStatusToStatusBadgeMessage = {
  ACTIVE: 'subscriptions.status.active',
  FAILED_PAYMENT: 'subscriptions.status.failedPayment',
  UNPAID: 'subscriptions.status.unpaid',
  SCHEDULED: 'subscriptions.status.scheduled',
  CANCELED: 'subscriptions.status.canceled',
  EXPIRED: 'subscriptions.status.expired',
  PAUSED: 'subscriptions.status.paused'
};

// Commerce Payments — backend types this as a plain string, so we own the set

export const COMMERCE_PAYMENT_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED'
};
export const commercePaymentStatusToStatusDotUse = {
  [COMMERCE_PAYMENT_STATUS.SUCCEEDED]: 'success',
  [COMMERCE_PAYMENT_STATUS.PROCESSING]: 'warning',
  [COMMERCE_PAYMENT_STATUS.FAILED]: 'danger'
};
export const commercePaymentStatusToMessage = {
  [COMMERCE_PAYMENT_STATUS.SUCCEEDED]: 'paymentHistory.status.succeeded',
  [COMMERCE_PAYMENT_STATUS.PROCESSING]: 'paymentHistory.status.processing',
  [COMMERCE_PAYMENT_STATUS.FAILED]: 'paymentHistory.status.failed'
};

// Payment Methods

export const PAYMENT_METHOD_TYPE = {
  CARD: 'CARD',
  ACH: 'ACH',
  BACS: 'BACS',
  PADS: 'PADS',
  SEPA: 'SEPA'
};